import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";

import { PERIOD_OPTIONS } from "./consts";
import { useTimespanPicker } from "./hooks";
import { PeriodOptionType } from "./types";
import { isMobile } from "../../../utils/responsive";
import { BaseDateInput } from "../../FormElement/BaseDateInput";
import DropdownSelect from "../../FormElement/DropdownSelect";

import "./styles.scss";

export interface ITimespanPickerProps {
  timespan: ReturnType<typeof useTimespanPicker>;
}

export const TimespanPicker: React.FC<ITimespanPickerProps> = ({
  timespan,
}) => {
  const { t: _t } = useTranslation();
  const tCommon = (key: string) => _t(`common.dropdown.${key}`);

  const [showPopup, setShowPopup] = useState<boolean>(false);

  return (
    <div className="timespan-picker">
      <OutsideClickHandler onOutsideClick={() => setShowPopup(false)}>
        <div className="date-drop">
          <button
            className="btn btn-gray-border"
            onClick={() => {
              setShowPopup((v) => !v);
            }}
          >
            <span className="bold">{tCommon(timespan.period)}</span>
            <div className="date-txt">
              {timespan.timespan.startDate?.format("YYYY-MM-DD")}
              {" - "}
              {timespan.timespan.endDate?.format("YYYY-MM-DD")}
            </div>
            <i className={`icons icon-drop ${showPopup ? "open" : ""}`}>
              &nbsp;
            </i>
          </button>
        </div>
        {showPopup && (
          <div className="date-panel">
            <div className="period-select">
              <div className="period-select-wrap">
                <DropdownSelect
                  fieldLabel={""}
                  value={timespan.period}
                  isTranslation={true}
                  items={PERIOD_OPTIONS}
                  classNameContainer={"sort-dropdown"}
                  onChange={(value: string) => {
                    timespan.changePeriod(value as PeriodOptionType);
                  }}
                />
              </div>
              <div
                className={`date-input-wrap ${
                  timespan.period !== "custom" ? "disabled" : ""
                }`}
              >
                <BaseDateInput
                  disabled={timespan.period !== "custom"}
                  fieldLabel={""}
                  value={timespan.timespan.startDate?.toDate() ?? null}
                  placeholder={""}
                  minDate={timespan.minDate}
                  maxDate={timespan.timespan.endDate?.toDate()}
                  onChange={(newDate) => {
                    timespan.changeStartDate(newDate as Date);
                  }}
                />
                <span className="to">~</span>
                <BaseDateInput
                  disabled={timespan.period !== "custom"}
                  fieldLabel={""}
                  value={timespan.timespan.endDate?.toDate() ?? null}
                  placeholder={""}
                  minDate={
                    timespan.timespan.startDate?.toDate()
                      ? new Date(timespan.timespan.startDate.toDate())
                      : undefined
                  }
                  onChange={(newDate) => {
                    timespan.changeEndDate(newDate as Date);
                  }}
                />
              </div>
            </div>
            <div
              className={`custom-timespan-select ${
                timespan.period !== "custom" ? "disabled" : ""
              }`}
            >
              <ReactDatePicker
                disabled={timespan.period !== "custom"}
                locale="ja"
                onChange={(dates: [Date | null, Date | null]) => {
                  timespan.changeTimespan(dates[0], dates[1]);
                }}
                minDate={new Date(timespan.minDate)}
                selectsRange
                inline
                startDate={timespan.timespan.startDate?.toDate()}
                endDate={timespan.timespan.endDate?.toDate()}
                monthsShown={isMobile() ? 1 : 2}
              />
            </div>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
};
